/**
 * The one German sentence stating what a password has to look like.
 *
 * **The rule itself lives on the server** — `PasswordExtensions.IsValidPassword`, a single regular expression
 * (`^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,32}$`) that every creation path runs. Nothing here
 * decides anything; this is only how the rule is *said*, and it is exported so that two screens asking a person
 * to invent a password cannot describe the same rule with two different sets of characters. That is not a
 * hypothetical failure mode: a hint that omits one accepted symbol turns a valid password into a refusal the
 * reader cannot explain.
 *
 * Stated up front rather than only in the refusal: a policy somebody meets on the first attempt costs nothing,
 * and one they discover by failing costs them the whole form.
 */
export const PASSWORD_POLICY_HINT =
  '8–32 Zeichen, mit Groß- und Kleinbuchstabe, Ziffer und einem Sonderzeichen (! @ # $ & *).';
